import "./style.scss";
import $ from "jquery";

let didAnimate;

$(function () {
    donat_animate();
});

$(window).on('scroll', function () {
    didAnimate = true;
});

setInterval(function () {
    if (didAnimate) {
        donat_animate();
        didAnimate = false;
    }
}, 150);

function donat_animate() {
    const element = $('.home-products__content-repeater');
    if (element.length) {
        element.each(function () {
            if ($(this).isInViewportCenter()) {
                $(this).addClass('animate');
            } else {
                $(this).removeClass('animate');
            }
        });
    }
}

$.fn.isInViewportCenter = function () {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + ($(window).height() * 0.5);

    return elementBottom > viewportTop && elementTop < viewportBottom;
};